"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxLengthExcludingParameters = MaxLengthExcludingParameters;
const class_validator_1 = require("class-validator");
function MaxLengthExcludingParameters(excludedParameters, maxLength, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "MaxLengthExcludingParameters",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value) {
                    let currentValueLength = value.length;
                    excludedParameters.forEach((parameter) => {
                        if (value.indexOf(parameter.text) > -1) {
                            currentValueLength -= parameter.length;
                        }
                    });
                    return typeof value === "string" && currentValueLength <= maxLength;
                },
            },
        });
    };
}
//# sourceMappingURL=MaxLengthExcludingParameters.js.map